import { Layout } from "antd";
import { observer } from "mobx-react";
import * as qs from "querystring";
import * as React from "react";

import UserStore from "stores/user";
import { getAppTitle } from "utils/app";
import * as httpClient from "utils/httpClient";
import "./style.css";

interface IProps {
  component: any;
  route: any;
  title?: string;
  user: UserStore;
}

@observer
export default class AuthenticatedLayout extends React.Component<IProps, object> {
  public state = {
    title: ""
  };
  
  public async componentWillMount() {
    const { token } = qs.parse(this.props.route.location.search.replace("?", ""));
    if (token) {
      sessionStorage.setItem("token", token.toString());
      const user = await httpClient.get("/v1/account/auth");
      sessionStorage.setItem("user", JSON.stringify(user));
      this.setState({ user });
    }
    await this.setState({ title: await getAppTitle() });
  }

  public render() {
    const { component: Component } = this.props;
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    const origin = (window.location.hostname.match(/.*(?=media)/) || [""])[0];

    return (
      <Layout>
        <Layout.Header className="mts-header">
          <img className="mts-header-logo" src={
            process.env.REACT_APP_LOGO ? process.env.REACT_APP_LOGO : (origin ? "//mts.muzhiyun.cn/logo.png?origin=" + origin : (process.env.REACT_APP_LOGO || "//images.muzhiyun.cn/static/muzhiyun-logo.png"))
          } />
          {this.props.title && <span className="mts-header-title">| {this.props.title}</span>}
          {user.userId && <span className="mts-header-user">
            {user.username} | <a onClick={this.signout}>退出</a>
          </span>}

        </Layout.Header>
        <Component match={this.props.route.match} location={this.props.route.location} />
        <Layout.Footer className="mts-footer">
          音视频剪辑©2018 Created by {process.env.REACT_APP_TITLE || this.state.title || "拇指云"}
        </Layout.Footer>
      </Layout>
    );
  }

  private signout() {
    sessionStorage.clear();
    window.close();
  }
}
